export const toleTranslations = {
  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_current: 'Toiture tôle / Métal',
  hero_h1: 'Toiture en tôle à Lévis : l\u0026rsquo;investissement qui dure 50 ans',
  hero_subtitle: "Acier prépeint, joint debout, ferblanterie traditionnelle. Une toiture qu\u0026rsquo;on installe une seule fois dans une vie.",
  hero_cta: 'Demander ma soumission tôle',
  hero_stat_1: 'Durée 40–50 ans',
  hero_stat_2: 'Garantie 15 ans pose',
  hero_stat_3: 'Valeur revente +5–7%',

  // Pourquoi la tôle
  pourquoi_h2: 'Pourquoi de plus en plus de propriétaires de Lévis choisissent la tôle',
  pourquoi_1_title: 'DURABILITÉ',
  pourquoi_1_desc: '40–50 ans de durée de vie réelle, résiste au gel-dégel, à la grêle, aux vents extrêmes du Saint-Laurent.',
  pourquoi_2_title: 'VALEUR REVENTE',
  pourquoi_2_desc: 'Une toiture tôle ajoute 5–7% à la valeur de votre maison selon les évaluateurs. Argument fort à la revente.',
  pourquoi_3_title: 'ÉCOLOGIQUE',
  pourquoi_3_desc: 'Acier 100% recyclable, reflète la chaleur (réduit climatisation), compatible toit blanc et panneaux solaires.',

  // Types de tôle
  types_h2: 'Les 3 systèmes de tôle qu\u0026rsquo;on installe à Lévis',
  type_1_title: 'JOINT DEBOUT',
  type_1_sub: 'Standing seam',
  type_1_desc: 'Le standard premium. Joints verticaux à pince mécanique, zéro vis apparente. Idéal toiture moderne ou patrimoniale. 50 ans+.',
  type_2_title: 'TÔLE À AGRAFES CACHÉES',
  type_2_sub: 'Snap-lock',
  type_2_desc: 'Bon compromis prix-durabilité. Installation rapide, agrafes dissimulées sous chaque panneau. 35–45 ans.',
  type_3_title: 'FERBLANTERIE TRADITIONNELLE',
  type_3_sub: 'Artisanale',
  type_3_desc: 'Pour maisons ancestrales ou projets prestige. Cuivre, acier galvanisé, finitions sur mesure. 75+ ans.',

  // Couleurs
  couleurs_h2: 'Les couleurs d\u0026rsquo;acier prépeint disponibles',
  couleurs_note: "Tous nos panneaux sont en acier galvanisé prépeint haute qualité, garantis 35–50 ans par le fabricant contre la décoloration.",

  // Prix
  prix_h2: "Prix d\u0026rsquo;une toiture en tôle à Lévis 2026",
  prix_table_type: 'Type de toiture',
  prix_table_price: 'Prix indicatif',
  prix_row1_type: 'Bungalow 1 200–1 500 pi² (agrafes cachées)',
  prix_row1_price: '14 000 $ – 22 000 $',
  prix_row2_type: 'Cottage 1 800–2 200 pi² (agrafes cachées)',
  prix_row2_price: '20 000 $ – 30 000 $',
  prix_row3_type: 'Maison patrimoniale joint debout',
  prix_row3_price: '25 000 $ – 50 000 $',
  prix_row4_type: 'Résidence prestige ferblanterie cuivre',
  prix_row4_price: '50 000 $ – 85 000 $+',
  prix_note: "Investissement initial supérieur au bardeau, mais 2× la durée de vie et valeur de revente accrue. Soumission précise après inspection.",

  // Process
  process_h2: 'Notre processus d\u0026rsquo;installation',
  process_step1_num: '1',
  process_step1_title: 'Inspection + mesure laser',
  process_step1_sub: '48h',
  process_step1_desc: 'On inspecte la structure existante et on prend des mesures laser précises de chaque pan.',
  process_step2_num: '2',
  process_step2_title: 'Soumission détaillée',
  process_step2_desc: 'Options couleur, système, finitions. Chaque poste détaillé. Signée si acceptée.',
  process_step3_num: '3',
  process_step3_title: 'Commande tôle sur mesure',
  process_step3_sub: '2–3 semaines',
  process_step3_desc: 'Vos panneaux sont fabriqués sur mesure en usine avec vos couleurs et vos côtes.',
  process_step4_num: '4',
  process_step4_title: 'Retrait + préparation',
  process_step4_desc: "On enlève l'ancienne toiture, on inspecte le pontage, on installe le pare-vapeur et l'isolation.",
  process_step5_num: '5',
  process_step5_title: 'Installation + garantie',
  process_step5_desc: "Pose des panneaux, ferblanterie, solins scellés. Remise de la garantie écrite 15 ans.",

  // Témoignage
  temoin_text: "On a hérité de la maison familiale à Saint-Nicolas il y a 4 ans. La toiture en bardeau avait 22 ans et commençait à couler près du foyer. On savait qu\u0026rsquo;on allait rester ici longtemps, alors on a décidé d\u0026rsquo;investir pour du long terme. Après avoir rencontré trois couvreurs, un couvreur partenaire de Couvreur-Lévis.com nous a impressionnés par son portfolio de maisons patrimoniales et sa connaissance de la tôle. On a choisi un joint debout ardoise avec agrafes cachées. Le rendu est spectaculaire. Les voisins s\u0026rsquo;arrêtent pour nous demander qui a fait la toiture. Mais surtout, on sait qu\u0026rsquo;on n\u0026rsquo;y retournera jamais. La garantie 15 ans pose nous donne la tranquillité d\u0026rsquo;esprit, mais la tôle va durer 50 ans. Ça valait chaque dollar.",
  temoin_name: 'Famille Tremblay-Bouchard',
  temoin_location: 'Saint-Nicolas',
  temoin_project: 'Toiture joint debout ardoise, 2 400 pi², mai 2025',

  // FAQ
  faq_h2: 'Questions fréquentes sur la toiture en tôle',
  faq_q1: 'La tôle fait-elle vraiment du bruit quand il pleut ?',
  faq_a1: 'Avec une installation professionnelle et un isolant rigide en polyiso sous la tôle, le bruit de la pluie est comparable à une toiture en bardeau. Le mythe du bruit vient des vieilles toitures tôle posées sans isolant. Nos clients nous disent qu\u0026rsquo;ils ne remarquent pas de différence.',
  faq_q2: 'Peut-on installer la tôle par-dessus l\u0026rsquo;ancienne toiture ?',
  faq_a2: 'Oui, dans certains cas. Si le pontage est sain et que la structure supporte le poids supplémentaire, on peut installer la tôle directement par-dessus le bardeau existant avec des contre-lattes. Ça réduit le coût et le temps. On évalue la structure lors de l\u0026rsquo;inspection gratuite.',
  faq_q3: 'Quelle garantie offrez-vous sur une toiture tôle ?',
  faq_a3: "Garantie écrite de 15 ans sur la main-d'œuvre et l'étanchéité. De plus, les fabricants (Ideal Roofing, Vicwest, Canam) offrent une garantie fabricant de 35 à 50 ans contre la perforation et la décoloration. Vous avez donc une double protection.",
  faq_q4: 'La tôle est-elle plus chère qu\u0026rsquo;une réfection en bardeau ?',
  faq_a4: "À l'achat, oui. Une toiture tôle coûte 1.5 à 2× plus cher qu'un bardeau d'asphalte. Mais sur la durée de vie, elle est moins chère : un bardeau doit être refait 2-3 fois pendant que la tôle tient 50 ans. Ajoutez la valeur de revente (+5-7%) et les économies d'énergie, et l'investissement devient très rentable.",
  faq_q5: 'Combien de temps prend l\u0026rsquo;installation complète ?',
  faq_a5: 'Un bungalow standard : 3 à 5 jours. Une maison de 2 étages ou un toit complexe : 5 à 8 jours. Le joint debout prend plus de temps car chaque pan est ajusté manuellement. On vous donne un calendrier précis dans la soumission.',

  // CTA Final
  cta_h2: 'Votre toiture en tôle à Lévis, faite pour durer',
  cta_subtitle: 'Inspection gratuite, soumission éditoriale, garantie 15 ans.',
  cta_button: 'Obtenir ma soumission',
  cta_phone: '418-476-9950',

  // Formulaire
  form_h2: 'Demandez votre soumission gratuite',
  form_subtitle: 'Remplissez le formulaire — on vous rappelle en 2h ouvrables.',
  form_success: 'Soumission envoyée !',
  form_success_sub: 'On vous rappelle dans les 2 prochaines heures ouvrables. Merci de nous faire confiance.',
  form_name_label: 'Nom complet',
  form_name_placeholder: 'Votre nom',
  form_phone_label: 'Téléphone',
  form_phone_placeholder: '418-476-9950',
  form_email_label: 'Courriel',
  form_email_placeholder: 'votre@email.com',
  form_system_label: 'Système de tôle souhaité',
  form_system_select: 'Sélectionnez un système',
  form_message_label: 'Description du projet',
  form_message_placeholder: 'Décrivez votre maison, superficie, style architectural, toiture actuelle...',
  form_char_count: '/500',

  // Header/Footer shared
  nav_home: 'Accueil',
  nav_services: 'Services',
  nav_about: 'À propos',
  nav_quote: 'Soumission',
  phone_number: '418-476-9950',
  cta_quote: 'Soumission gratuite',
  footer_brand: 'Couvreur-Lévis.com',
  footer_address: 'Lévis, QC, Canada',
  footer_email: 'contact@couvreur-levis.com',
  footer_services_title: 'Services',
  footer_link_refaction: 'Réfection toiture',
  footer_link_repair: 'Réparation',
  footer_link_flat: 'Toit plat',
  footer_link_metal: 'Tôle et métal',
  footer_link_inspection: 'Inspection',
  footer_links_title: 'Liens',
  footer_link_about: 'À propos',
  footer_link_quote: 'Soumission',
  footer_link_legal: 'Mentions légales',
  footer_link_privacy: 'Politique de confidentialité',
  footer_link_blog: 'Blog',
  footer_copyright: '© 2026 Couvreur-Lévis.com. Tous droits réservés.',
  footer_hours_title: 'Heures',
  footer_hours_week: 'Lun–Ven : 7h00 – 18h00',
  footer_hours_weekend: 'Sam–Dim : 8h00 – 16h00',
};

export default toleTranslations;